module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.data), function(store) {
    return _c('li', {
      staticClass: "store-item"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "title": store.storeName
      }
    }, [_c('img', {
      staticClass: "scrollLoading",
      attrs: {
        "src": store.storeImgsUrl,
        "alt": store.storeName,
        "width": "306",
        "height": "229"
      }
    })])], 1), _vm._v(" "), _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "title": store.storeName
      }
    }, [_vm._v("\n      " + _vm._s(store.storeName) + "\n      ")])], 1), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(store.storeName))]), _vm._v(" "), _c('p', {
      staticClass: "phonenum"
    }, [_vm._v(_vm._s(store.tel))]), _vm._v(" "), _c('p', {
      staticClass: "adress"
    }, [_vm._v(_vm._s(store.attr))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af08505"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/same-city-businesses/list.vue
// module id = 1576
// module chunks = 1